export function dashboardPathForUser(user) {
  if (!user?.role) return "/dashboard";
  if (user.role === "admin") return "/admin/dashboard";
  return `/${user.role}/dashboard`;
}